import { render, staticRenderFns } from "./PotvrdaOPlaciDialog.vue?vue&type=template&id=2ce92826&scoped=true"
import script from "./PotvrdaOPlaciDialog.vue?vue&type=script&lang=js"
export * from "./PotvrdaOPlaciDialog.vue?vue&type=script&lang=js"
import style0 from "./PotvrdaOPlaciDialog.vue?vue&type=style&index=0&id=2ce92826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce92826",
  null
  
)

export default component.exports